export default {
	data() {
		return {
			userDefaultValue: { key: '', label: 'Selecciona un usuario' }
		};
	},
	computed: {
		userValue() {
			if (typeof this.value !== 'object' || this.value === null) {
				return this.parseDefaultValue();
			}

			return this.value;
		}
	},
	methods: {
		async userFetch(value) {
			this.dataLoading = true;

			const results = await this.$gestios.users.list({ page: 1, search: value, limit: 5 });

			this.dataLoading = false;

			this.data = [];
			if (results.ok) {
				results.data.forEach((item) => {
					this.data.push({
						text: item.Nick,
						value: item.ID,
						data: item
					});
				});
			}
		},
		userChange(value) {
			if (value) {
				const index = this.data.findIndex((item) => item.value === value.key);

				let data = null;
				if (index > -1) ({ data } = this.data[index]);

				this.$emit('input', this.parseValue({ ...value, data }));
			}

			this.data = [];
			this.dataLoading = false;
		},
		userParseValue(value) {
			let needToConvert = false;

			switch (typeof value) {
				case 'object':
					if (value.ID !== undefined) needToConvert = true;

					if (needToConvert) {
						return {
							label: value.Nick.toString(),
							key: value.ID.toString(),
							data: value
						};
					}

					if ((value.key || value.key === 0) && value.label) {
						// if (Number.isInteger(value.key)) value.key = value.key.toString();
						// value.label = value.label.map.replace(/(\r\n|\n|\r|\t)/gm, '');
						return value;
					}
					break;

				default:
					return this.parseDefaultValue();
			}

			return value;
		},
		userParseDefaultValue() {
			let defaultValue = this.userDefaultValue;

			if (this.defaultValue !== null) {
				if (typeof this.defaultValue === 'object') {
					if (this.defaultValue.key !== undefined && this.defaultValue.label !== undefined) {
						defaultValue = {
							key: this.defaultValue.key,
							label: this.defaultValue.label,
							data: this.defaultValue
						};
					}
				}
			}

			return defaultValue;
		}
	}
};
